import { Instagram, MapPin, Phone } from "lucide-react";
import { TikTokIcon } from "./icons";
import { LINKS, INFO } from "../../data";

export const Footer = () => (
  <footer className="relative bg-black border-t border-neon-green/20 px-5 sm:px-8 lg:px-12 py-16">
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
        <div>
          <div className="flex items-baseline gap-3">
            <span className="font-heading text-7xl sm:text-8xl text-neon-green neon-glow-green leading-none">67</span>
            <span className="font-heading text-4xl sm:text-5xl text-neon-yellow leading-none">WINGS & TENDERS</span>
          </div>
          <p className="font-graffiti text-neon-green text-3xl mt-3 -rotate-1">thank you for supporting local!</p>
        </div>

        <div className="flex flex-col gap-3 font-body text-neutral-400">
          <a href={LINKS.maps} target="_blank" rel="noopener noreferrer" data-testid="footer-address" className="flex items-center gap-2 hover:text-neon-green transition-colors">
            <MapPin size={18} className="text-neon-green" /> {INFO.address}
          </a>
          <a href={LINKS.phone} data-testid="footer-phone" className="flex items-center gap-2 hover:text-neon-green transition-colors">
            <Phone size={18} className="text-neon-green" /> {INFO.phone}
          </a>
          <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 hover:text-neon-green transition-colors">
            <Instagram size={18} className="text-neon-green" /> {INFO.instagram}
          </a>
          <a href={LINKS.tiktok} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" className="flex items-center gap-2 hover:text-neon-green transition-colors">
            <TikTokIcon size={18} className="text-neon-green" /> {INFO.tiktok}
          </a>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-neutral-900 flex flex-col sm:flex-row justify-between gap-2 font-body text-xs text-neutral-600 uppercase tracking-[0.15em]">
        <span>© {new Date().getFullYear()} {INFO.full}. Powered by Sabor Con Sazón 831.</span>
        <span>Fresh · Never Frozen · Salinas, CA</span>
      </div>
    </div>
  </footer>
);

export default Footer;
